import { useState, useEffect } from 'react';

export default function useDebounce(value, callback, delay) {
  const [newValue, setNewValue] = useState(value);
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(newValue);
      callback(newValue);
    }, delay);

    return () => clearTimeout(handler);
  }, [newValue]);

  // In most cases the debounced value isn't needed but we can return it anyway
  return [newValue, setNewValue, debouncedValue];
}
